/* @flow */
import { em } from 'polished';

export default {
  root: {
    width: em(20),
    height: em(20),
  },
};
